import PropTypes from 'prop-types';

export default PropTypes.shape({
  surf: PropTypes.string,
  swell: PropTypes.string,
  wind: PropTypes.string,
  tide: PropTypes.string,
});
